export enum NotificationMethod {
    EMAIL = 'EMAIL',
    IN_APP = 'IN_APP'
}

export const notificationMethodDisplay = {
    [NotificationMethod.EMAIL]: 'Email',
    [NotificationMethod.IN_APP]: 'In app'
};
